module.exports = __webpack_public_path__ + "static/img/hykbj.4ddd4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/hykbj.png
// module id = 8c1t
// module chunks = 1